var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgPreviewButtonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8806_30371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.10156 13.8438C5.10156 14.2303 5.25512 14.601 5.52846 14.8744C5.8018 15.1477 6.17253 15.3013 6.55909 15.3013",
    stroke: "white",
    strokeWidth: 1.45753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55909 0.726562C6.17253 0.726563 5.8018 0.880123 5.52846 1.15346C5.25512 1.4268 5.10156 1.79753 5.10156 2.18409",
    stroke: "white",
    strokeWidth: 1.45753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6763 2.18409C19.6763 1.79753 19.5227 1.4268 19.2494 1.15346C18.976 0.880123 18.6053 0.726563 18.2188 0.726562",
    stroke: "white",
    strokeWidth: 1.45753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2188 15.3013C18.6053 15.3013 18.976 15.1477 19.2494 14.8744C19.5227 14.601 19.6763 14.2303 19.6763 13.8438",
    stroke: "white",
    strokeWidth: 1.45753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3018 19.6768H3.64162C2.8685 19.6768 2.12704 19.3697 1.58036 18.823C1.03368 18.2764 0.726563 17.5349 0.726562 16.7618V5.10156",
    stroke: "white",
    strokeWidth: 1.45753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 0.726562H13.8526",
    stroke: "white",
    strokeWidth: 1.45753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 15.3047H13.8526",
    stroke: "white",
    strokeWidth: 1.45753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6797 6.55469V9.46974",
    stroke: "white",
    strokeWidth: 1.45753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10156 6.55469V9.46974",
    stroke: "white",
    strokeWidth: 1.45753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8806_30371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.4054,
    height: 20.4054,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewButtonIcon);
export default __webpack_public_path__ + "static/media/preview-button-icon.0b16d9a6b1c26db0e151b38c9f3de315.svg";
export { ForwardRef as ReactComponent };